<script setup>
import { cn } from "~/utils/cn";

defineProps({
  size: { type: String, default: "md", validator: (v) => ["sm", "md", "lg"].includes(v) },
  active: { type: Boolean, default: undefined },
});
</script>

<template>
  <button
    type="button"
    :class="
      cn(
        'h-8 cursor-pointer whitespace-nowrap rounded-md border border-gray-300 bg-gray-100 px-3 py-0 text-sm font-medium text-gray-500 shadow-xs hover:text-gray-900 data-[state=active]:bg-white data-[state=active]:text-gray-900',
        $attrs.class ?? ''
      )
    "
    :data-state="active === undefined ? undefined : active ? 'active' : 'inactive'"
  >
    <slot />
  </button>
</template>
